import { COLORS } from '@btime/constants'
import React from 'react'

import { useOpenAvailabilityDetailsAction } from '../../_actions/useAvailabilityActionsList'
import FlexGrid from '../../../../components/structure/FlexGrid'
import Icon from '../../../../components/shapes/Icon'
import Link from '../../../../components/actions/Link'
import { SmallText, Text } from '../../../../components/presentation/Text'

// Unlike the generic `PlacePresenter` (which opens the plain `places/show` modal),
// clicking a place here must open the availability details modal (`availability/show`):
// it's the one with the availability-specific Details/History tabs and the open
// non-compliances list for this place.
const AvailabilityPlaceCell = ({ place }) => {
  const details = useOpenAvailabilityDetailsAction(place)

  return (
    <Link block onClick={details.click} underlineOnHover>
      <FlexGrid justify="flex-start" gutter={0.15}>
        <Text size="small">{place.name}</Text>
        <Icon name="BsSearch" color={COLORS.dark3} size="0.8rem" />
      </FlexGrid>
      <SmallText size="xxsmall" color={COLORS.dark3}>
        {place.resume}
      </SmallText>
    </Link>
  )
}

export default AvailabilityPlaceCell
